"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.heroSlideButtonsProps = exports.heroSlideButtonColorArray = exports.HeroSlideButtonColor = void 0;

var _heroSlideButtonsProp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeroSlideButtonColor;
exports.HeroSlideButtonColor = HeroSlideButtonColor;

(function (HeroSlideButtonColor) {
  HeroSlideButtonColor["CLARET"] = "claret";
  HeroSlideButtonColor["PRIMARY"] = "primary";
  HeroSlideButtonColor["BLACK"] = "black";
  HeroSlideButtonColor["WHITE"] = "white";
  HeroSlideButtonColor["SEASHELL"] = "seashell";
  HeroSlideButtonColor["MOCASSIN"] = "mocassin";
  HeroSlideButtonColor["BLACK_GHOST"] = "black-ghost";
  HeroSlideButtonColor["WHITE_GHOST"] = "white-ghost";
})(HeroSlideButtonColor || (exports.HeroSlideButtonColor = HeroSlideButtonColor = {}));

var heroSlideButtonColorArray = Object.values(HeroSlideButtonColor);
exports.heroSlideButtonColorArray = heroSlideButtonColorArray;
var heroSlideButtonsProps = (_heroSlideButtonsProp = {}, _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.CLARET, {
  variant: 'solid',
  color: 'primaryDark'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.PRIMARY, {
  variant: 'solid',
  color: 'primary'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.BLACK, {
  variant: 'solid',
  color: 'gray800'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.WHITE, {
  variant: 'solid',
  color: 'white'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.SEASHELL, {
  variant: 'solid',
  color: 'secondaryLight'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.MOCASSIN, {
  variant: 'solid',
  color: 'secondary'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.BLACK_GHOST, {
  variant: 'outlined',
  color: 'gray800'
}), _defineProperty(_heroSlideButtonsProp, HeroSlideButtonColor.WHITE_GHOST, {
  variant: 'outlined',
  color: 'white'
}), _heroSlideButtonsProp);
exports.heroSlideButtonsProps = heroSlideButtonsProps;